import { useFormContext, useFormState } from "react-hook-form";

import { useTheme } from "@up/data";
import {
  ELEMENT_WRAPPER_MB,
  ElementWrapper,
  Label,
  LabelCheckbox,
} from "@up/form";

export function TCPAConsent() {
  const { register } = useFormContext();
  const { errors } = useFormState();

  const KEY = "student-tcpa-consent";
  const ERRORS = errors[KEY];
  const registerProps = register(KEY);
  const theme = useTheme();

  return (
    <ElementWrapper className={ELEMENT_WRAPPER_MB} hasErrors={!!ERRORS}>
      <Label>
        Please confirm that this is your phone number (not someone else&apos;s)
        and that we may contact you
      </Label>
      <div className="grid">
        <LabelCheckbox
          text={`Yes, this is my mobile phone number, and I agree that ${theme.partnerName} and its service provider Kaplan North America, LLC may deliver or cause to be delivered information, including advertisements and telemarketing messages, regarding their educational services by text to my telephone number using automated technology. Consent is not required to receive information or to apply, enroll, or participate in any program. Message & data rates may apply. Message frequency may vary. Reply STOP to unsubscribe or HELP for help or email us at ${theme.supportEmail}.`}
        >
          <input
            id={`${registerProps["name"]}`}
            type="checkbox"
            {...registerProps}
          />
        </LabelCheckbox>
      </div>
    </ElementWrapper>
  );
}
